import axios from "axios";
import { get_access_token } from "./get_access_token";

export const get_sailings = async (navy, searchData) => {
  const access_token = await get_access_token("");
  const apiUrl = process.env.REACT_APP_API_URL;

  let data = await axios({
    method: "get",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": access_token,
  },
    url: `${apiUrl}/api/search_tryp_by_navy`,
    params: {
      navy: navy,
      searchData: searchData,
    },
  });

  // origen: origen,
  // destiny: destiny,
  // way: way,
  // departureDate: fixDate(departureDate),
  // returnDate: fixDate(returnDate),
  // numAdults: numAdults,
  // numKids: numKids,
  // numBabies: numBabies,
  // vehicleType: vehicleType,
  // vehicleLong: vehicleLong,
  // vehicleTrailer: vehicleTrailer,
  // vehicleTrailerLong: vehicleTrailerLong,
  // vehicleTrailerHeight: vehicleTrailerHeight,
  // advantage: advantage,
  // family: family,
  // residence: residence,

  return data.data;
};
